import { Component } from '@angular/core';

@Component({
    selector: 'lib-tracking-results',
    imports: [],
    templateUrl: './tracking-results.component.html',
    styleUrl: './tracking-results.component.scss'
})
export class TrackingResultsComponent {

}
